import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { Glossary } from '@utils/types/glossary';

export const useGetGlossary = (glossaryId: number) => {
  const fetchGlossary = async () => {
    const { data } = await Axios.get<Glossary>(
      GET_URL(glossaryId.toString(), 'false', '0').glossary!
    );
    return data;
  };

  return useQuery<Glossary, AxiosError<BaseError>>(
    ['glossary', glossaryId],
    fetchGlossary,
    {
      useErrorBoundary: false,
      staleTime: 5 * 60 * 1000,
      enabled: !!glossaryId
    }
  );
};
